import React, { useEffect } from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { ListItemButton, ListItemIcon, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export default function Politicas(props) {

    useEffect(() => {
        //document.title = props.titulo;
      }, [props.titulo])

    return (
        <div>
            <Typography variant="h4">Política de privacidad para el uso de <a href='https://play.google.com/store/apps/details?id=com.jhonmorales.jchessmanager'>JChess Manager</a> publicada en Play Store</Typography>
            <ListDividers />

            <Typography variant="h4">Solicitar eliminación de cuenta de <a href='https://play.google.com/store/apps/details?id=com.jhonmorales.jchessmanager'>JChess Manager</a> publicada en Play Store</Typography>
            <ListDividersEliminacion />
        </div>
    )
}

const style = {
    width: '100%',
    bgcolor: 'background.paper',
};

function ListDividers() {
    let politicas = [
        "El respeto a tu privacidad está garantizado.",
        "Al autenticarte con Google compartirás tu nombre, correo, y fotografía con la aplicación, los cuales son usados para identificarte en los Torneos online.",
        "La aplicación contiene anuncios.",
        "El uso de la aplicación es totalmente gratuito.",
        "Cualquier duda o consulta puede enviarlas al correo electrónico jhonmoralesestrada@gmail.com",
        "La aplicación no accede a la ubicación de tu dispositivo.",
        "La aplicación no registra direcciones IP.",
        "La aplicación no accede a tus contactos ni agendas."
    ]
    return (
        <List sx={style} component="nav" aria-label="mailbox folders">
            <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
                Al instalar la aplicación usted indica que conoce los siguientes puntos de la política de privacidad:
            </Typography>
            <div>
                {politicas.map((valor, index) =>
                    <ListItem disablePadding key={index}>
                        
                            <ListItemIcon>
                                <CheckIcon />
                            </ListItemIcon>
                            <ListItemText primary={valor} />
                        
                    </ListItem>
                )}
            </div>
            <Typography sx={{ mt: 2, mb: 4 }} variant="h6" component="div">
                Nuestra Política de privacidad puede cambiar, por lo que se sugiere revisarla periódicamente.
            </Typography>

        </List>
    );
}

function ListDividersEliminacion() {
    let politicas = [
        "Solicida la eliminación de tu cuenta al correo jhonmoralesestrada@gmail.com",
        "Adjunta el correo electrónico de la cuenta que quieres eliminar, el correo con el que envías los datos debe coincidir con la cuenta que deseas eliminar.",
        "Se realizará la eliminación de tu cuenta en un plazo de 7 días aproximadamente.",
        "Se eliminarán tus credenciales de acceso a la aplicación y los datos asociados a tu cuenta (Id, nombre, correo, fotografía).",
        "Tus datos compartidos con anterioridad no serán eliminados",
        "No podrás recuperar tu cuenta una vez sea eliminada.",
    ]
    return (
        <List sx={style} component="nav" aria-label="mailbox folders">
            <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
                Para solicitar eliminar tu cuenta debes seguir los siguientes pasos
            </Typography>
            <div>
                {politicas.map((valor, index) =>
                    <ListItem disablePadding key={index}>
                        
                            <ListItemIcon>
                                <CheckIcon />
                            </ListItemIcon>
                            <ListItemText primary={valor} />
                        
                    </ListItem>
                )}
            </div>
            <Typography sx={{ mt: 2, mb: 4 }} variant="h6" component="div">
                Nuestra Política de eliminación de cuenta puede cambiar, por lo que se sugiere revisarla periódicamente.
            </Typography>

        </List>
    );
}
